import React, { useEffect } from 'react'
import { useHistory } from 'react-router';
import { ExploreSearch } from '..';
import { Link } from 'react-router-dom';

import {
    AngleSmallLeft,
    Home
} from '../../../../assets'

import '../../../../assets/icons/icons.css'

const SearchTopNav = (props) => {

    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="white-space"></div>
            <div className="topnav-search-container">
                <div className="topnav-left-side" onClick={() => {
                    if(props.isClicked) {
                        props.handleDetailClick();
                    }
                    else {
                        history.goBack()
                    }
                }}>
                    <AngleSmallLeft id="back-small-icon" />
                </div>
                <div className="topnav-search-content">
                    <ExploreSearch/>
                </div>
            </div>
        </>
    )
}

export default SearchTopNav
